var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83366 14.9993C6.29662 13.3327 7.68551 12.0827 10.0003 12.0827C12.3151 12.0827 13.704 13.3327 14.167 14.9993M10.0009 9.86046C11.2281 9.86046 12.2231 8.86602 12.2231 7.63824C12.2231 6.41104 11.2281 5.41602 10.0009 5.41602C8.77368 5.41602 7.77866 6.41104 7.77866 7.63824C7.77401 8.86136 8.76146 9.85639 9.98458 9.86046H10.0009ZM10.0003 18.3327C7.67291 18.3327 6.5092 18.3327 5.5737 18.0053C3.89809 17.419 2.58066 16.1016 1.99434 14.426C1.66699 13.4905 1.66699 12.3268 1.66699 9.99935C1.66699 7.67193 1.66699 6.50823 1.99434 5.57272C2.58066 3.89711 3.89809 2.57968 5.5737 1.99336C6.5092 1.66602 7.67291 1.66602 10.0003 1.66602C12.3277 1.66602 13.4914 1.66602 14.427 1.99336C16.1026 2.57968 17.42 3.89711 18.0063 5.57272C18.3337 6.50823 18.3337 7.67193 18.3337 9.99935C18.3337 12.3268 18.3337 13.4905 18.0063 14.426C17.42 16.1016 16.1026 17.419 14.427 18.0053C13.4914 18.3327 12.3277 18.3327 10.0003 18.3327Z",
    stroke: "#4D6BF6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileActiveIcon);
export default __webpack_public_path__ + "static/media/ProfileActiveIcon.80e943f71589704c5f13a217a517e93b.svg";
export { ForwardRef as ReactComponent };